<template>
  <div style="position: relative;width: 100%;height: 100%">
    <div class="outerLayer">
      <vue-particles
        color="#e6c802"
        :particleOpacity="0.2"
        :particlesNumber="60"
        shapeType="circle"
        :particleSize="4"
        linesColor="#e6c802"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.5"
        :linesDistance="150"
        :moveSpeed="3"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
      >
      </vue-particles>
    </div>
    <div class="almighty-grap">
      <Nav />
    </div>
    <div class="aim-logo"></div>
    <div class="menu-title">
      <div style="color: #FFFFFF">
        <!--`
                <div style="width: 100px;height: 100px;float: left;background-image: url('/static/img/homepage/中交.png');background-size: 100% 100%;"></div>
        -->
        <span style=";font-size: 7vh;font-weight: 600">AIM</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span style=";font-size: 5vh;font-weight: 600">FOCUS</span>
        <div><span style=";font-size: 1.7vh;font-weight: 500;letter-spacing: 0.5vh">平台化物联网控制系统</span></div>
      </div>
    </div>
    <div class="almighty-all">
      <div @click="test" class="img-div" style="background-image: url('/static/img/homepage/5.gif');width: 8.2%;height: 65%"></div>
      <div class="img-div" style="background-image: url('/static/img/homepage/6.gif');width: 15%;height: 100%;left: 10%;top: -12%"></div>
      <div class="img-div" style="background-image: url('/static/img/lengdongzhan/xuanzhuan.gif');width: 12%;height: 87%;left: 26%;top: -10%"></div>
      <div class="img-div" style="background-image: url('/static/img/lengdongzhan/xuanzhuan.gif');width: 12%;height: 87%;left: 26%;top: -10%"></div>
      <div @click="designTool" class="img-div" style="background-image: url('/static/img/lengdongzhan/chilun.gif');width: 8%;height: 60%;left: 42%;top: 4%"></div>
      <div @click="productData"  class="img-div" style="background-image: url('/static/img/homepage/6fcd21daa3a0e56062c2109234c6c9ba.gif');width: 6%;height: 42%;left: 57%;top: 13%"></div>
      <div @click="test" class="img-div tit-font" style="top: 65%;left: -1%">数字孪生工具</div>
      <div class="img-div tit-font" style="top: 65%;left: 15%">AI 工具</div>
      <div class="img-div tit-font" style="top: 65%;left: 28.7%">知识图谱</div>
      <div @click="designTool" class="img-div tit-font" style="top: 65%;left: 43.3%">设计工具</div>
      <div @click="productData"  class="img-div tit-font" style="top: 65%;left: 57%">产品资料</div>
      <div class="img-div tit-font" style="top: 65%;left: 57%"></div>
    </div>
    <div style="width:100%; height:30px;position:absolute;bottom:0; overflow:hidden;z-index: 121">
      <el-row>
        <el-col :span="24">
          <div style="text-align: center;line-height: 30px">
            <a style="font-size: 12px;color: #bfbfbf" href="https://beian.miit.gov.cn/#/Integrated/recordQuery">备案序号：苏ICP备20029776号-1</a>
            <span style="font-size: 12px;color: #bfbfbf">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
            <a style="font-size: 12px;color: #bfbfbf">苏公网安备</a>
            <span style="font-size: 12px;color: #bfbfbf">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;Copyright © 2009-2021 埃安美(苏州)物联技术有限公司</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <Toollogin :show="show"  @hideModal="hideModal" @submit="submit">
    </Toollogin>

  </div>
</template>

<script>
  import Nav from '../pages/homePageAssembly/nav'
  import Toollogin from '../pages/homePageAssembly/toollogin'
  export default {
    name: 'Demo',
    components: {
      Nav,Toollogin
    },
    data () {
      return {
        fullHeight: document.documentElement.clientHeight, // 检测页面高度
        activeIndex: '1',
        show:false,
      }
    },
    watch: {
      fullHeight (val) {
        if(!this.timer) {
          this.fullHeight = val
          this.timer = true
          let that = this
          setTimeout(function (){
            that.timer = false
          },400)
        }
      }
    },
    computed: {

    },
    mounted () {
      const that = this
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight
          that.fullHeight = window.fullHeight
        })()
      }
    },
    methods: {
      test(){
        this.$router.push({name: 'Login'})
      },
      test1(){
        this.$router.push({name: 'Visualization'})
      },
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      },
      backLogin(){
        this.$router.push({name: 'Login'})
      },
      designTool(){
       // this.$router.push({name: 'Designtool'})
        this.show = true
      },
      hideModal() {
        // 取消弹窗回调
        this.show = false
      },
      submit() {
        // 确认弹窗回调
        this.show = false
      },
      productData(){
        this.$router.push({name: 'Product'})
      }
    }
  }
</script>
<style scoped>
  .outerLayer{
    position: absolute;
    z-index: 99;
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    background-image: url("/static/img/homepage/1.png");
    overflow: hidden;
  }
  .menu-title{
    position: absolute;
    z-index: 100;
    left: 20%;
    top: 40%;
  }
  .almighty-all{
    position: absolute;
    z-index: 101;
    width: 40%;
    height: 10%;
    left: 20%;
    top: 54%;
  }
  .img-div{
    position: absolute;
    background-size: 100% 100%;
    cursor: pointer;
    z-index: 101;
  }
  .img-siz1{
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    cursor: pointer;
  }
  .tit-font{
    color: #FFFFFF;
    font-size: 0.7vh;
  }
  .almighty-grap{
    position: absolute;
    z-index: 101;
    width: 40%;
    height: 8%;
    left: 50%;
    top: 5%;
  }
  .aim-logo{
    width: 4%;
    height: 2.1%;
    position: absolute;
    background-image: url("/static/img/logOne.png");
    background-size: 100% 100%;
    z-index: 111;
    left: 92%;
    top: 6.4%;
    cursor: pointer;
  }
  .dropdown-link{
    color: #FFFFFF;
    font-size: 1.8vh;
  }
</style>



// WEBPACK FOOTER //
// src/pages/homePage.vue